import { render, staticRenderFns } from "./u-action-sheet.vue?vue&type=template&id=6766c527&scoped=true&"
import script from "./u-action-sheet.vue?vue&type=script&lang=js&"
export * from "./u-action-sheet.vue?vue&type=script&lang=js&"
import style0 from "./u-action-sheet.vue?vue&type=style&index=0&id=6766c527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6766c527",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-action-sheet/u-action-sheet.vue"
export default component.exports